import { memo } from 'react';
import { useAppStore } from '../state/store';
import { SnapIndicator } from '../tools/snapping';
import { TransformPreview } from '../tools/edit';
import { AnalysisOverlay } from './AnalysisOverlayLayer';
import { PolarTrackOverlay } from './PolarTrackOverlay';

/**
 * System Overlays Layer (Phase 2 decomposition)
 *
 * Isolated behind memo() so tool-hook state changes in SceneContent
 * (pointer-move storms during drawing) never re-render the overlays.
 *
 * Composition:
 * - SnapIndicator     -> OSNAP marker (activeSnap from the snap store)
 * - TransformPreview  -> gizmo preview for the selected ids
 * - AnalysisOverlay   -> ZEBRA/DRAFT/CURVATURE/DIR/SHOWEDGES/SECTIONPLANE
 *                        display modes from useViewStore (command parity I/J)
 * - PolarTrackOverlay -> POLAR/ISODRAFT/SMARTTRACK input guides
 *
 * NOTE: SelectionBoxOverlay is plain DOM (absolute-positioned div) and must
 * live OUTSIDE the R3F Canvas tree — see Viewport.tsx. The three reconciler
 * crashes with "Div is not part of the THREE namespace" otherwise.
 */
export const SystemOverlayLayer = memo(function SystemOverlayLayer() {
    const selectedIds = useAppStore((state) => state.selectedIds);

    return (
        <>
            <SnapIndicator />
            <TransformPreview selectedIds={selectedIds} />
            <AnalysisOverlay />
            <PolarTrackOverlay />
        </>
    );
});
